export enum EmployeesTab {
  All = "all",
  Managers = "managers",
  ServiceStaff = "serviceStaff",
}
